import React from 'react';
import { WorkspaceSplitLayout } from '@auw/workspace-ui';

interface WorkspaceSplitPaneProps {
  primaryContent: React.ReactNode;
}

export const WorkspaceSplitPane: React.FC<WorkspaceSplitPaneProps> = (props) => {
  return <WorkspaceSplitLayout {...props} />;
};
